import Vue from 'vue'
import Vuex from 'vuex'
import ModuleUser from './modules/user'
import ModuleGame from './modules/game'
import ModuleApp from './modules/app'
import ModuleSignatureKey from './modules/signatureKey'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app: ModuleApp,
    user: ModuleUser,
    game: ModuleGame,
    signatureKey: ModuleSignatureKey
  }
})
